export default __webpack_public_path__ + "static/media/log-off-icon.bac2d418.svg";